// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1yeEY","alertIcon":"ConfirmModal_alertIcon__2RD2M"};